module.exports = __webpack_public_path__ + "static/img/people6.68acbee.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/life/people6.jpg
// module id = SM8p
// module chunks = 1